module.exports = __webpack_public_path__ + "media/images/check-2fbe841c1ec49d8222ae1c6ada7967f4.svg";